export const enum NavigationItemType {
  ABOUT = 'About',
  CONTACT_US = 'Contact us',
}
